(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};

    this.setHeaderHeight();
    this.updateHeaderBounds();

    window.matchMedia('(max-width: 990px)').addEventListener('change', () => {
      this.setHeaderHeight();
      this.updateHeaderBounds();
    });

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    }

    this.currentScrollTop = 0;
    this.preventReveal = false;

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }

  updateHeaderBounds() {
    this.headerBounds = this.header.getBoundingClientRect();
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver(() => {
      this.updateHeaderBounds();
    });

    observer.observe(this.header);
  }

onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const stickyHeaderType = this.getAttribute('data-sticky-type');
    const scrollThreshold = 10; 

    this.updateHeaderBounds();

    if (scrollTop > this.currentScrollTop + scrollThreshold && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (stickyHeaderType === 'on-scroll-up') {
            this.header.style.transform = 'translateY(-20px)';
        }

        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
    } 
    else if (scrollTop < this.currentScrollTop - scrollThreshold) {
        if (stickyHeaderType === 'on-scroll-up') {
            this.header.style.removeProperty('transform');
        }
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reveal.bind(this));
    } 
    else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
}

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }
}

customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();
})();
